const typography = {
  fontFamily: [
    '"Segoe UI"',
    '-apple-system',
    'BlinkMacSystemFont',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"'
  ].join(','),
  h1: {
    fontWeight: 500
  },
  h2: {
    fontWeight: 500
  },
  h3: {
    fontWeight: 500
  },
  h4: {
    fontWeight: 500
  },
  h5: {
    fontWeight: 500
  }
};

export default typography;
